export default "__VITE_ASSET__B2NW63eW__"